import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useCallback } from "react";

/**
 * Custom hook for reCAPTCHA v3 verification
 * Must be used inside a RecaptchaWrapper or GoogleReCaptchaProvider
 * @returns {Object} - verifyRecaptcha function and ready state
 */
export function useRecaptcha() {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const verifyRecaptcha = useCallback(
    async (action) => {
      if (!executeRecaptcha) {
        console.warn("reCAPTCHA not yet available");
        return null;
      }

      try {
        const token = await executeRecaptcha(action);
        return token;
      } catch (error) {
        console.error("reCAPTCHA verification failed:", error);
        return null;
      }
    },
    [executeRecaptcha]
  );

  return {
    verifyRecaptcha,
    isReady: !!executeRecaptcha,
  };
}
